// Import all visualization JSON files
import InGeneral_Themes from './InGeneral_Themes.json'
import InGeneral_Themes_Analysis from './InGeneral_Themes_Analysis.json'
import InGeneral_Themes_Sentiment from './InGeneral_Themes_Sentiment.json'
import InGeneral_Themes_Emotion from './InGeneral_Themes_Emotion.json'
import InGeneral_Emotion from './InGeneral_Emotion.json'
import InGeneral_Emotion_Analysis from './InGeneral_Emotion_Analysis.json'
import InGeneral_Sentiment_Analysis from './InGeneral_Sentiment_Analysis.json'
import InGeneral_Sentiment from './InGeneral_Sentiment.json' // Placeholder file


// TikTok Analysis Data
import TikTok_Sentiment from './TikTok_Sentiment.json'
import TikTok_Emotions from './TikTok_Emotions.json'
import TikTok_Themes from './TikTok_Themes.json'

// Export a map of filename to data
export const visualizationData: Record<string, any> = {
  'InGeneral_Themes.json': InGeneral_Themes,
  'InGeneral_Themes_Analysis.json': InGeneral_Themes_Analysis,
  'InGeneral_Themes_Sentiment.json': InGeneral_Themes_Sentiment,
  'InGeneral_Themes_Emotion.json': InGeneral_Themes_Emotion,
  'InGeneral_Emotion.json': InGeneral_Emotion,
  'InGeneral_Emotion_Analysis.json': InGeneral_Emotion_Analysis,
  'InGeneral_Sentiment_Analysis.json': InGeneral_Sentiment_Analysis,
  'InGeneral_Sentiment.json': InGeneral_Sentiment, // Placeholder
  'TikTok_Sentiment.json': TikTok_Sentiment,
  'TikTok_Emotions.json': TikTok_Emotions,
  'TikTok_Themes.json': TikTok_Themes,
}

// Helper function to get data by filename
export const getVisualizationData = (filename: string): any => {
  return visualizationData[filename] || null
}